import { SWMS_METHOD_ITEM_TYPES_ITEMS_URL, SWMS_METHOD_ITEM_FILTER_ITEMS_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

export const getSwmsMethodItemFilterItems = (typeId, abortController) => () => {
    if (!typeId) {
        return Promise.resolve([]);
    }

    return scopeApiInstance.get(
        `${SWMS_METHOD_ITEM_FILTER_ITEMS_URL}/${typeId}/filter-items`,
        { ...abortController }
    )
        .then((res) => {
            if (res && res.data && Array.isArray(res.data.data)) {
                return Promise.resolve(res.data.data);
            }
            return Promise.resolve([]);
        })
        .catch(error => {
            if (error) {
                return Promise.reject(
                    error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
                );
            }
            return Promise.reject(null);
        });
};

export const getSwmsMethodItems = (typeId, page = 1, params = {}, abortController) => {
    if (!typeId) {
        return Promise.reject(Strings.generic_error);
    }

    return scopeApiInstance.get(
        `${SWMS_METHOD_ITEM_TYPES_ITEMS_URL}/${typeId}/items`,
        {
            params: { page, ...params },
            ...abortController
        }
    )
        .then((res) => {
            if (res && res.data && res.data.data) {
                return Promise.resolve(res.data.data);

            } else {
                return Promise.reject(Strings.generic_error);
            }
        })
        .catch(error => {
            if (typeof error === "string") {
                return Promise.reject(error);
            }
            if (error) {
                return Promise.reject(
                    error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
                );
            } else {
                return Promise.reject(null);
            }
        })
};

export const addSwmsMethodItem = (typeId, formData) => () => {
    if (!typeId) {
        return Promise.reject(Strings.generic_error);
    }

    return scopeApiInstance.post(`${SWMS_METHOD_ITEM_TYPES_ITEMS_URL}/${typeId}/items`, formData)
        .then((res) => {
            if (res && res.data && res.data.message) {
                return Promise.resolve(res.data.message);
            }
            return Promise.reject(Strings.generic_error);
        })
        .catch((error) => {
            if (error) {
                return Promise.reject(
                    error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
                );
            }
            return Promise.reject(null);
        });
};

export const updateSwmsMethodItem = (typeId, id, formData) => () => {
    if (!typeId || !id) {
        return Promise.reject(Strings.generic_error);
    }

    return scopeApiInstance.put(`${SWMS_METHOD_ITEM_TYPES_ITEMS_URL}/${typeId}/items/${id}`, formData)
        .then((res) => {
            if (res && res.data && res.data.message) {
                return Promise.resolve(res.data.message);
            }
            return Promise.reject(Strings.generic_error);
        })
        .catch((error) => {
            if (error) {
                return Promise.reject(
                    error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
                );
            }
            return Promise.reject(null);
        });
};

export const deleteSwmsMethodItem = (typeId, id) => () => {
    if (!typeId || !id) {
        return Promise.reject(Strings.generic_error);
    }

    return scopeApiInstance.delete(`${SWMS_METHOD_ITEM_TYPES_ITEMS_URL}/${typeId}/items/${id}`)
        .then((res) => {
            if (res && res.data && res.data.message) {
                return Promise.resolve(res.data.message);
            }
            return Promise.reject(Strings.generic_error);
        })
        .catch((error) => {
            if (error) {
                return Promise.reject(
                    error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
                );
            }
            return Promise.reject(null);
        });
};